/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IDocumentConfigurationComponentScope extends ng.IScope {
        entityWithConfig: any;
        docConfigTypePropertyName: string;
        docConfigPropertyName: string;
        docConfigIdPropertyName: string;
        processConfigId: string;
        allowMultipleFiles: boolean;

        documentConfigurationTypeChanged: () => void;
        existingDocConfigChanged: () => void;

        systemDocumentConfiguration: Wars.Domain.Model.Documents.SystemDocumentConfiguration;
        documentConfigurations: Wars.Domain.Model.Documents.DocumentConfiguration[];
        docConfigTypeInternal: number;
    }

    export class DocumentConfigurationComponent implements IDirective {
        public controller = ["$scope", "systemLevelService", "documentService", DocumentConfigurationComponentController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/documentConfigurationComponent.html';
        public restrict: string = "E";

        public scope: any = {
            entityWithConfig: "=",
            docConfigTypePropertyName: "@",
            docConfigPropertyName: "@",
            docConfigIdPropertyName: "@",
            processConfigId: "=",
            allowMultipleFiles: "="
        };

        public link(scope: IDocumentConfigurationScope,
            element: ng.IAugmentedJQuery,
            attrs: ng.IAttributes,
            controller: DocumentConfigurationController): void {
        }
    }

    export class DocumentConfigurationComponentController implements IController {

        constructor(
            private $scope: IDocumentConfigurationComponentScope,
            private systemLevelService: services.SystemLevelService,
            private documentService: services.DocumentService)
        {
            this.$scope.documentConfigurations = [];
            systemLevelService.getSystemLevelDocumentConfiguration().then(
                (sysLevel) => {
                    this.$scope.systemDocumentConfiguration = sysLevel.systemDocumentConfiguration;
                    this.$scope.documentConfigurations = this.$scope.documentConfigurations.concat(sysLevel.myDocumentConfigurations);
                });

            if (this.$scope.processConfigId) {
                documentService.getDocumentConfigs(this.$scope.processConfigId).then(
                    (docConfigs) => {
                        this.$scope.documentConfigurations = this.$scope.documentConfigurations.concat(docConfigs);
                    });
            }

            this.$scope.documentConfigurationTypeChanged = () => this.documentConfigurationTypeChanged();
            this.$scope.existingDocConfigChanged = () => this.existingDocConfigChanged();

            this.$scope.docConfigTypeInternal = this.getDocConfigType();
        }

        private getDocConfigType(): number {
            if (!this.$scope.entityWithConfig) return undefined;
            return this.$scope.entityWithConfig[this.$scope.docConfigTypePropertyName];
        }

        private getDocumentConfig(): Wars.Domain.Model.Documents.DocumentConfiguration {
            if (!this.$scope.entityWithConfig) return undefined;
            return this.$scope.entityWithConfig[this.$scope.docConfigPropertyName];
        }

        private documentConfigurationTypeChanged(): void {
            if (<any>this.$scope.docConfigTypeInternal === "1") this.$scope.docConfigTypeInternal = 1;
            if (<any>this.$scope.docConfigTypeInternal === "2") this.$scope.docConfigTypeInternal= 2;

            if (this.$scope.docConfigTypeInternal === Wars.Domain.Model.Codes.Enums.DocumentConfigType.Custom) {
                var documentConfig = this.getDocumentConfig();
                if (!documentConfig || documentConfig.processConfiguration_id || documentConfig.systemLevel_id) {
                    var newDocConfig = this.documentService.createDocumentConfig();
                    this.systemLevelService.saveAllChanges(
                        () => {
                            this.$scope.entityWithConfig[this.$scope.docConfigTypePropertyName] = this.$scope.docConfigTypeInternal;
                            this.$scope.entityWithConfig[this.$scope.docConfigPropertyName] = newDocConfig;
                            this.$scope.entityWithConfig[this.$scope.docConfigIdPropertyName] = newDocConfig.id;
                        });
                }
            }
            else if (this.$scope.docConfigTypeInternal === Wars.Domain.Model.Codes.Enums.DocumentConfigType.ReUsable) {
                this.$scope.entityWithConfig[this.$scope.docConfigTypePropertyName] = this.$scope.docConfigTypeInternal;
                this.$scope.entityWithConfig[this.$scope.docConfigPropertyName] = undefined;
                this.$scope.entityWithConfig[this.$scope.docConfigIdPropertyName] = undefined;
            }
        }

        private existingDocConfigChanged(): void {
            if (this.getDocConfigType() === Wars.Domain.Model.Codes.Enums.DocumentConfigType.ReUsable) {
                this.systemLevelService.saveAllChanges();
            }
        }
    }
}

warsApp.registerDirective('DocumentConfigurationComponent', []);